export const SAVE_CONNECTION_HEADER = 'connection-header/SAVE_CONNECTION_HEADER';
export const SAVE_CONNECTION_HEADER_SUCCESS = 'connection-header/SAVE_CONNECTION_HEADER_SUCCESS';
export const UPDATE_CONNECTION_HEADER = 'connection-header/UPDATE_CONNECTION_HEADER';
export const UPDATE_CONNECTION_HEADER_SUCCESS = 'connection-header/UPDATE_CONNECTION_HEADER_SUCCESS';
export const DELETE_CONNECTION_HEADER = 'connection-header/DELETE_CONNECTION_HEADER';
export const DELETE_CONNECTION_HEADER_SUCCESS = 'connection-header/DELETE_CONNECTION_HEADER_SUCCESS';
export const FETCH_CONNECTION_HEADERS = "connection-header/FETCH_CONNECTION_HEADERS";
export const FETCH_CONNECTION_HEADERS_SUCCESS = "connection-header/FETCH_CONNECTION_HEADERS_SUCCESS";


